<template>
  <div>
    <CJumbotron
      v-if="[1, 14, 15].includes(this.$store.state.data.access_level)"
      class="tickets no_back"
    >
      <h1 class="display-3">
        صفحه مدیریت نهال ها
        <span v-if="filters.user"
          >- {{ users.filter((i) => i.value == filters.user)[0].label }}</span
        >
      </h1>
      <p class="lead">
        <b
          style="
            font-weight: 100;
            color: #00325a;
            padding-bottom: 10px;
            display: inline-block;
          "
        >
          مشتریانی که با ما آشنا شده‌اند و درخواست مشاوره دارند، به آنها "نهال"
          می‌گوییم.
        </b>
        <br />
        <span> در این صفحه به نهال‌ها دسترسی دارید. </span>
      </p>
      <div class="seedling_page">
        <img src="/img/seedling_page.png" alt="" />
      </div>
    </CJumbotron>
    <CRow>
      <CCol sm="6" md="2">
        <div class="seedlingBox">
          <img src="/img/new_seedlings.svg" />
          <span class="count">{{ statistics.count }}</span>
          <span class="dec">کل بذر‌ها</span>
        </div>
      </CCol>
      <CCol sm="6" md="2">
        <div class="seedlingBox moshavere">
          <img src="/img/moshavere_seedlings.svg" />
          <span class="count">{{ statistics.counseling }}</span>
          <span class="dec">در انتظار مشاوره</span>
        </div>
      </CCol>
      <CCol sm="6" md="2">
        <div class="seedlingBox peygiri">
          <img src="/img/peygiri_seedlings.svg" />
          <span class="count">{{ statistics.follow_up }}</span>
          <span class="dec">در حال پیگیری</span>
        </div>
      </CCol>
      <CCol sm="6" md="2">
        <div class="seedlingBox success">
          <img src="/img/success_seedlings.svg" />
          <span class="count">{{ statistics.successful }}</span>
          <span class="dec">موفق شده</span>
        </div>
      </CCol>
      <CCol sm="6" md="2">
        <div class="seedlingBox failed">
          <img src="/img/failed_seedlings.svg" />
          <span class="count">{{ statistics.failed }}</span>
          <span class="dec">ناموفق</span>
        </div>
      </CCol>
      <CCol sm="6" md="2">
        <div class="seedlingBox" style="padding: 0px">
          <div class="seedling_header">
            <span class="title">سطح شما</span>
            <span class="value">1</span>
          </div>
          <div class="seedling_header" style="background: #eee">
            <span class="title_value"
              >نرخ تبدیل : {{ statistics.conversion_rate }} درصد</span
            >
          </div>
          <div class="seedling_header" style="background: #dcdada">
            <span class="title_value"
              >سرعت تبدیل : {{ statistics.conversion_speed }} روز</span
            >
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard>
      <CCardHeader class="hamkaran_header"> فیلتر گزارشات </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="3">
            <CInput
              label="نام سرنخ ...  "
              placeholder="عبارت را جهت جستجو وارد نمایید"
              v-on:keyup.enter="
                page = 1;
                pagPage = 1;
                pages = 0;
                getData();
              "
              v-model="q"
            />
          </CCol>
          <CCol
            md="3"
            v-if="
              $store.state.data.access_level === 1 ||
              $store.state.data.access_level === 14
            "
          >
            <i
              v-if="filters.user"
              class="select_remover fa-solid fa-xmark"
              @click="
                filters.user = '';
                getData();
              "
            ></i>
            <CSelect
              :label="$t('seedlings.data.assign_to.name')"
              :placeholder="$t('seedlings.data.assign_to.placeholder')"
              :options="users"
              @change="getData()"
              :value.sync="filters.user"
            />
          </CCol>
          <CCol md="12">
            <CButton
              style="margin-left: 9px;"
              :title="$t('seedlings.status.0')"
              color="dark"
              :variant="(filters.status === '0')? '' : 'outline'"
              @click="filters.status=(filters.status === '0')? '' : '0';getData();"
            >
              {{ $t("seedlings.status.0") }}
            </CButton>
            <CButton
              style="margin-left: 9px;"
              :title="$t('seedlings.status.1')"
              color="primary"
              :variant="(filters.status === '1')? '' : 'outline'"
              @click="filters.status=(filters.status === '1')? '' : '1';getData();"
            >
              {{ $t("seedlings.status.1") }}
            </CButton>
            <CButton
              style="margin-left: 9px;"
              :title="$t('seedlings.status.2')"
              color="warning"
              :variant="(filters.status === '2')? '' : 'outline'"
              @click="filters.status=(filters.status === '2')? '' : '2';getData();"
            >
              {{ $t("seedlings.status.2") }}
            </CButton>
            <CButton
              style="margin-left: 9px;"
              :title="$t('seedlings.status.3')"
              color="success"
              :variant="(filters.status === '3')? '' : 'outline'"
              @click="filters.status=(filters.status === '3')? '' : '3';getData();"
            >
              {{ $t("seedlings.status.3") }}
            </CButton>
            <CButton
              style="margin-left: 9px;"
              :title="$t('seedlings.status.4')"
              color="danger"
              :variant="(filters.status === '4')? '' : 'outline'"
              @click="filters.status=(filters.status === '4')? '' : '4';getData();"
            >
              {{ $t("seedlings.status.4") }}
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <div
          style="
            text-align: left;
            display: inline-block;
            float: left;
            margin-right: 10px;
          "
        >
          <CButton
            @click="
              page = 1;
              pagPage = 1;
              pages = 0;
              getData();
            "
            color="primary"
          >
            جستجو
          </CButton>
        </div>

        <div style="text-align: right; float: right; display: inline-block">
          <CButton style="color: #fff" @click="modal_show()" color="info">
            افزودن سرنخ
          </CButton>
        </div>
      </CCardFooter>
    </CCard>
    <CCard>
      <CCardBody class="" :class="!showEmpty ? 'no_m_p' : 'mhcloud'">
        <CElementCover v-if="loading" :opacity="1" class="h-loadin">
          <CSpinner size="5xl" />
          <br />
          <div>در حال بارگزاری</div>
        </CElementCover>
        <CRow v-if="showEmpty" class="nothing">
          <CCol lg="12" sm="12">
            <br /><br />
            <CIcon name="cil-warning" size="sm" />
            هیچ نهالی تعریف نشده است
            <br /><br /><br />
          </CCol>
        </CRow>

        <CRow v-if="!showEmpty" class="hamkaran-report">
          <CCol md="12" sm="12">
            <div style="position: relative">
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="width: 10px">#</th>
                      <th>{{ $t("seedlings.data.full_name.name") }}</th>
                      <th>{{ $t("seedlings.data.mobile.name") }}</th>
                      <th>{{ $t("seedlings.data.email.name") }}</th>
                      <th>زمان ثبت</th>
                      <th>{{ $t("seedlings.data.source.name") }}</th>
                      <th>{{ $t("seedlings.data.assign_to.name") }}</th>
                      <th style="width: 108px">
                        {{ $t("seedlings.data.status.name") }}
                      </th>
                      <th style="text-align: center; width: 100px">
                        {{ $t("seedlings.data.operations.name") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in rows" :key="row.id">
                      <td class="id">
                        <img v-if="row.special" class="special_lead" src="/img/special.png" />
                        {{ row.id }}
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 0">😡</span>
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 1">😡</span>
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 2">🙁</span>
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 3">😶</span>
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 4">😊</span>
                        <span :title="'رضایت از مشاوره '+row.survey+' از 5'" v-if="row.survey == 5">🥰</span>
                      </td>
                      <td class="name">
                        {{ row.full_name }}
                        <span class="seedling_description" v-if="row.description">
                          {{ row.description }}
                        </span>
                      </td>
                      <td class="mobile">
                        <span>{{ row.mobile }}</span>
                      </td>
                      <td class="email">
                        <span>{{ row.email }}</span>
                      </td>
                      <td
                        :title="
                          new Date(row.created_at)
                            | moment('dddd, jMMMM Do jYYYY, h:mm:ss a')
                        "
                      >
                        {{ new Date(row.created_at) | moment("from", "now") }}
                      </td>
                      <td class="source">
                        <span>{{ row.source }}</span>
                      </td>
                      <td class="assign_to" :title="row.assign_to">
                        <span v-if="row.assign_to != null">{{
                          $store.state.data.users.filter(
                            (i) => i.id == row.assign_to
                          )[0].name
                        }}</span>
                        <span v-if="row.assign_to == null">بدون مسئول</span>
                      </td>
                      <td class="status">
                        <span>{{ $t("seedlings.status." + row.status) }}</span>
                      </td>
                      <td class="oprate">
                        <CButtonGroup style="width: 100%;">
                          <CButton @click="modal_show(row)" color="success">
                            ویرایش
                          </CButton>
                          <CButton @click="modal_show(row, 1)" color="warning">
                            حذف
                          </CButton>
                        </CButtonGroup>
                        <CButtonGroup style="width: 100%;margin-top:3px;margin-bottom:3px">
                          <CButton style="width: 100%;" v-if="row.didar == null" variant="outline" @click="add_to_didar(row)" color="primary">
                            <CSpinner v-if="storeLoading" tag="span" size="md" />
                            <span v-if="!storeLoading"> ثبت در دیدار </span>
                          </CButton>
                          <CButton style="width: 100%;color:#fff" target="_blank" v-if="row.didar != null" :href="'https://app.didar.me/deal/'+row.didar" color="primary">
                          معامله در دیدار
                          </CButton>
                        </CButtonGroup>
                        
                        <CButtonGroup>
                          <CButton @click="sendSMS(row)" color="sms">
                            <CSpinner v-if="sendSMSq[row.id] !== undefined" tag="span" size="md" />
                            <span v-if="sendSMSq[row.id] === undefined">پیامک</span>
                            
                          </CButton>
                          <CButton @click="sendWhatsapp(row)" color="whatsapp">  
                            <CSpinner v-if="sendWPPq[row.id] !== undefined" tag="span" size="md" />
                            <span v-if="sendWPPq[row.id] === undefined">واتساپ</span>
                          </CButton>
                        </CButtonGroup>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <div id="integration">
      <CPagination
        :activePage.sync="pagPage"
        :pages="pages"
        v-on.update:activePage="changePage()"
        size="lg"
        align="center"
      />
    </div>

    <CModal :title="add_new.title" color="info" size="lg" :show.sync="showForm">
      <CRow>
        <CCol md="5">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.full_name.name')"
            :placeholder="$t('seedlings.data.full_name.placeholder')"
            v-model="seedling.full_name"
          />
        </CCol>
        <CCol md="4">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.email.name')"
            :placeholder="$t('seedlings.data.email.placeholder')"
            v-model="seedling.email"
          />
        </CCol>
        <CCol md="3">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.mobile.name')"
            :placeholder="$t('seedlings.data.mobile.placeholder')"
            v-model="seedling.mobile"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="3">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.source.name')"
            :placeholder="$t('seedlings.data.source.placeholder')"
            v-model="seedling.source"
          />
        </CCol>
        <CCol md="3">
          <CSelect
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.status.name')"
            :placeholder="$t('seedlings.data.status.placeholder')"
            :options="[
              { value: 0, label: $t('seedlings.status.0') },
              { value: 1, label: $t('seedlings.status.1') },
              { value: 2, label: $t('seedlings.status.2') },
              { value: 3, label: $t('seedlings.status.3') },
              { value: 4, label: $t('seedlings.status.4') },
            ]"
            :value.sync="seedling.status"
          />
        </CCol>
        <CCol md="3">
          <CSelect
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.assign_to.name')"
            :placeholder="$t('seedlings.data.assign_to.placeholder')"
            :options="users"
            :value.sync="seedling.assign_to"
          />
        </CCol>
        <CCol md="3">
          <CSelect
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.special.name')"
            :placeholder="$t('seedlings.data.special.placeholder')"
            :options="[
              { value: 0, label: $t('seedlings.special.0') },
              { value: 1, label: $t('seedlings.special.1') },
            ]"
            :value.sync="seedling.special"
          />
        </CCol>
        <CCol md="6">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.description.name')"
            :placeholder="$t('seedlings.data.description.placeholder')"
            v-model="seedling.description"
          />
        </CCol>
        <CCol md="6">
          <CInput
            :disabled="for_remove == 1"
            :label="$t('seedlings.data.didar.name')"
            :placeholder="$t('seedlings.data.didar.placeholder')"
            v-model="seedling.didar"
          />
        </CCol>
      </CRow>

      <div slot="footer" class="integrationMessage">
        <span>
          {{ basePrice }}
        </span>
      </div>

      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="showForm = false"
      >
        {{ $t("common.CANCEL") }}
      </button>

      <CButton
        v-if="for_remove == 0"
        slot="footer"
        type="button"
        class="btn btn-info"
        @click="storeData()"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
        <span v-if="!storeLoading"> {{ add_new.btn }} </span>
      </CButton>

      <CButton
        v-if="for_remove == 1"
        slot="footer"
        type="button"
        class="btn btn-danger"
        @click="removeSeedling(seedling.id)"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-trash" />
        <span v-if="!storeLoading">{{ $t("common.GO_REMOVE") }}</span>
      </CButton>
    </CModal>
  </div>
</template>
<style>
.nemad-anime {
  position: absolute;
  left: 68px;
  top: 14px;
}
img.special_lead {
    position: absolute;
    width: 20px;
    margin-top: -29px;
    right: 16px;
}
.no_back.jumbotron:before {
  background: none !important;
}
@media (max-width: 576px) {
  .row.d-sm-none.tickets_tables_header {
    display: none !important;
  }
  .row.tickets_table div {
    display: flex !important;
    justify-content: flex-start;
    align-content: flex-start;
    flex-direction: row;
    text-align: right;
    line-height: 30px;
  }
  .row.tickets_table div a.btn.btn-outline-primary {
    margin-top: 11px;
  }
}
span.bg_ani {
  top: -10px;
  position: absolute;
  left: -14px;
  opacity: 1;
  z-index: 0;
}

.red {
  color: #d40000;
}
.ltr.form-group input {
  direction: ltr;
}
.integrationMessage {
  position: absolute;
  display: block;
  right: 13px;
  /* float: right; */
}
.integration_help {
  text-align: right;
  background: #eee;
  padding: 19px 10px;
  margin-bottom: 15px;
  border-radius: 6px;
}
.box.not_active.not_membership {
  background: #fbcaca;
  border-color: #f56f6f;
  filter: blur(0.2px);
  color: red;
}
.box.not_active:hover {
  background: #efefef;
  animation: none;
  border: 1px solid #333;
  color: #727272;
}

.box.not_active {
  filter: blur(1px);
  cursor: no-drop;
}
.box img {
  width: 91px;
  line-height: 40px;
  display: inline-block;
  padding: 21px 10px;
  filter: grayscale(1);
}
.box {
  width: 106px;
  background: #efefef;
  transition: 0.3s all;
  height: 95px;
  border-radius: 5px;
  border: 1px solid #333;
  padding: 5px;
  cursor: pointer;
  margin: 14px 5px;
  float: right;
}
.box span {
  font-size: 12px;
}
.box i {
  display: block;
  font-size: 52px;
  padding-bottom: 8px;
  padding-top: 4px;
}
.mhcloud h1 {
  display: inline-block;
  width: 100%;
  text-align: right;
  font-weight: 100;
}
.box:hover {
  background: #01b0cf;
  color: #fff;
  border-color: #0091bb;
}
.edit_btn {
  width: 21px;
  height: 21px;
  padding: 0px;
  margin-right: 10px;
}
.box:hover {
  animation: zoom-in-zoom-out 2.5s ease-out infinite;
}
.tickets_table {
  border-radius: 3px;
  border: 1px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
}
.tickets_table:hover {
  cursor: pointer;
  background: rgba(238, 238, 238, 0.589);
}
.center {
  display: flex;
  align-content: space-around;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.row.tickets_tables_header {
  border-radius: 3px;
  border: 0px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
  color: #727272;
}
.jumbotron.tickets .btn {
  margin: 0px 5px;
}
.row.ticket p {
  white-space: break-spaces;
}
span.seedling_description {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #666;
}
</style>
<script>
export default {
  name: "seedlingsList",
  components: {},

  data() {
    return {
      sendSMSq:[],
      sendWPPq:[],
      data: null,
      page: 1,
      pagPage: 1,
      pages: 0,
      q: "",
      showForm: false,
      storeLoading: false,
      rows: null,
      loading: true,
      showSeedlings: false,
      showEmpty: false,
      basePrice: "",
      filters: {
        user: "",
        status: ''
      },
      statistics: {
        count: "-",
        failed: "-",
        successful: "-",
        follow_up: "-",
        counseling: "-",
        conversion_rate: "-",
        conversion_speed: "-",
      },
      seedling: {
        id: "",
        full_name: "",
        mobile: "",
        email: "",
        status: "",
        special: 0,
        description: "",
        tenant_id: "",
        assign_to: "",
        source: "",
        tendidarant_id: "",
      },
      for_remove: 0,
      users: [],
      add_new: {},
      lottie: {
        autoplay: true,
        speed: 1,
        loop: true,
        width: "260px",
      },
    };
  },
  created() {
    this.$root.$i18n.locale = "en";
  },
  mounted() {
    this.q = this.$route.params.prefix ? this.$route.params.prefix : "";
    this.getData();
    this.setUsers();
  },
  methods: {
    setUsers() {
      let users = this.$store.state.data.users;
      users.forEach(this.setUsersFinal);
    },
    setUsersFinal(item, index, arr) {
      if (item.active && (item.access_level == 15 || item.access_level == 14 || item.id == 271))
        this.users.push({ value: item.id, label: item.name });
    },
    numberFormat(val) {
      let formatted = new Intl.NumberFormat("en", {
        currency: "IRR",
        style: "currency",
      })
        .format(val)
        .replace("IRR", "");
      return formatted + " ریال";
    },
    go(target) {
      this.$router.push({ path: target });
    },
    modal_show: function (data, for_remove = 0) {
      this.showForm = true;
      this.for_remove = for_remove;
      // add new
      if (data) {
        this.seedling.full_name = data.full_name;
        this.add_new.btn = this.$t("seedlings.edit_btn");
        this.add_new.title =
          this.$t("seedlings.edit_btn") + " (" + this.seedling.full_name + ")";
        this.seedling.id = data.id;
        this.seedling.mobile = data.mobile;
        this.seedling.email = data.email;
        this.seedling.status = data.status;
        this.seedling.tenant_id = data.tenant_id;
        this.seedling.assign_to = data.assign_to;
        this.seedling.source = data.source;
        this.seedling.didar = data.didar;
        this.seedling.special = data.special;
        this.seedling.description = data.description;
      } else {
        console.log("omad injaaaa");
        this.add_new.title = this.$t("seedlings.add_new_btn");
        this.add_new.btn = this.$t("seedlings.add_new_btn");
        this.seedling.id = 0;
        this.seedling.full_name = null;
        this.seedling.mobile = null;
        this.seedling.email = null;
        this.seedling.status = null;
        this.seedling.tenant_id = "100";
        this.seedling.assign_to = null;
        this.seedling.source = null;
        this.seedling.didar = null;
        this.seedling.special = 0;
        this.seedling.description = null;
      }
      if (this.for_remove == 1) {
        this.add_new.title =
          this.$t("seedlings.add_remove_btn") +
          " (" +
          this.seedling.full_name +
          ")";
      }
    },
    getData: function () {
      this.loading = true;
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      axios
        .get(
          "https://api.hamkaran.cloud/api/v1/admin/seedlings?datefrom=" +
            "&page=" +
            this.page +
            "&q=" +
            this.q +
            "&user=" +
            this.filters.user +
            "&status=" +
            this.filters.status
        )
        .then((response) => {
          this.loading = false;
          this.rows = response.data.data.rows.data;
          this.statistics = response.data.data.statistics;
          this.showSeedlings = this.rows.length > 0 ? 1 : 0;
          this.showEmpty = this.rows.length == 0 ? 1 : 0;
          this.pages = response.data.data.rows.last_page;
        })
        .catch((error) => {
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: "Eroor",
              status: "500",
              data: ["خطا بارگزاری اطلاعات"],
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },

    changePage: function () {
      if (this.pages) {
        if (this.page != this.pagPage) {
          this.page = this.pagPage;
          this.getData();
        }
      }
    },

    storeData: function () {
      if (!this.storeLoading) {
        this.storeLoading = true;
        this.storeLoading = true;
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/seedling",
            this.seedling
          )
          .then((response) => {
            this.storeLoading = false;
            this.showForm = false;
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "save succes",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.errorcount + 1;
            console.log(error.response);
            this.storeLoading = false;
            const alert = {
              error_msg: {
                statusText: "خطا در ذخیره سازی",
                status: error.response.status,
                data: error.response.data,
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    },
    removeSeedling: function (seedling_id) {
      if (!this.storeloading) {
        this.storeLoading = true;
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .delete(
            "https://api.hamkaran.cloud/api/v1/admin/seedling/" + seedling_id
          )
          .then((response) => {
            this.storeLoading = false;
            this.showForm = false;
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "Remove success",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: "Eroor",
                status: "500",
                data: [error.response],
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    },
    add_to_didar: function (seedling) {
      if (!this.storeloading) {
        this.loading = true;
        this.storeLoading = true;
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/seedling/didar/add/"+seedling.id,
            seedling
          )
          .then((response) => {
            this.storeLoading = false;
            this.showForm = false;
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "Successful add To didar",
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: "Error",
                status: "500",
                data: [error.response],
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    },
    sendSMS: function (seedling) {
      if (this.sendSMSq[seedling.id] === undefined) {
        this.$set(this.sendSMSq, seedling.id, seedling.id);
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/seedling/marketing/sms/"+seedling.id,
            seedling
          )
          .then((response) => {
            this.$delete(this.sendSMSq, seedling.id);
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "Successful Send sms to "+seedling.full_name,
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: "Error",
                status: "500",
                data: [error.response],
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    },
    sendWhatsapp: function (seedling) {
      if (this.sendWPPq[seedling.id] === undefined) {
        this.$set(this.sendWPPq, seedling.id, seedling.id);
        var token = localStorage.getItem("token");
        if (token)
          axios.defaults.headers.common.Authorization = "Bearer " + token;
        axios
          .post(
            "https://api.hamkaran.cloud/api/v1/admin/whatsapp/seedling/"+seedling.id,
            seedling
          )
          .then((response) => {
            this.$delete(this.sendWPPq, seedling.id);
            this.getData();
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: null,
                status: null,
                data: [],
              },
              successMessage: "Successful Send Whatsapp to "+seedling.full_name,
              successcount: count,
              errorcount: 0,
            };
            this.$store.commit("set", ["alert", alert]);
          })
          .catch((error) => {
            const count = this.$store.state.alert.successcount + 1;
            const alert = {
              error_msg: {
                statusText: "Error",
                status: "500",
                data: [error.response],
              },
              successMessage: "",
              successcount: 0,
              errorcount: count,
            };
            this.$store.commit("set", ["alert", alert]);
          });
      }
    },
  },
};
</script>
